import React from "react";
import Card from "components/Card/Card";
import { useParams } from "react-router-dom";
import Page from "components/Page/Page";
import UpdateClinicForm from "./components/UpdateClinicForm";
import DetailSelector from "./components/DetailSelector";

const ClinicDetails = () => {
  const { id } = useParams();
  const orgId = id ? Number(id) : 0;

  return (
    <Page
      title="Clinic Details"
      subTitle={id ? `Clinic ID: ${id}` : "Edit clinic information and manage related records"}
    >
      <div className="flex flex-col gap-5">
        <Card
          title="Clinic settings"
          subTitle="Update clinic name and currency."
        >
          <UpdateClinicForm />
        </Card>
        <Card>
          <DetailSelector orgId={orgId} />
        </Card>
      </div>
    </Page>
  );
};

export default ClinicDetails;
